import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/base.component';
import { UserHistoryActionsEnum } from 'src/app/shared/enum/userHistoryActions';
import { UserHistoryServicesEnum } from 'src/app/shared/enum/userHistoryService';
import { SuccessDto } from 'src/app/shared/models/success-dto';
import { SaveUserHistoryService } from 'src/app/shared/services/history/saveHistory';
import { AppStateInterface } from 'src/app/store/appState.interface';
import { invokeDeleteFranchiseAndSomeLocations, invokeFranchisedCompanyNamesByFranchise, invokeFranchiseFilter, setDeleteFranchiseSuccess } from 'src/app/store/franchise/franchise.action';
import { initialState } from 'src/app/store/franchise/franchise.reducers';
import { deleteFranchiseSuccessSelector, resultFranchisedCompanyNamesByFranchiseSelector } from 'src/app/store/franchise/franchise.selectors';


type locationForNgSelect = {
  label: string,
  companyName: string
}

@Component({
  selector: 'app-delete-franchise',
  templateUrl: './delete-franchise.component.html',
  styleUrls: ['./delete-franchise.component.scss']
})
export class DeleteFranchiseComponent extends BaseComponent implements OnInit {
  @Input() companyName: string;

  franchisedCompanyNames$: Observable<string[] | null>;
  locationsPerFranchise: locationForNgSelect[] = [];
  
  selectedLocations: string[] = [];

  franchiseDeleted$: Observable<SuccessDto | null>;

  constructor(
    private store: Store<AppStateInterface>,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private translate: TranslateService,
    private saveHistory: SaveUserHistoryService,
  ) { 
    super(store);

    this.franchisedCompanyNames$ = this.store
      .pipe(select(resultFranchisedCompanyNamesByFranchiseSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.franchiseDeleted$ = this.store
      .pipe(select(deleteFranchiseSuccessSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.store.dispatch(invokeFranchisedCompanyNamesByFranchise({ companyName: this.companyName }));

    this.franchisedCompanyNames$.subscribe((data) => {
      if (data) {
        this.locationsPerFranchise = data.map(name => ({ label: "deleteFranchisePopup.allLocations", companyName: name }));
      }
    });

    this.franchiseDeleted$.subscribe((data) => {
      if (data) {
        this.toastr.success(
          this.translate.instant("response.success." + data.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(
          invokeFranchiseFilter({
            franchiseFilter: initialState.franchiseFilter,
          })
        );
        this.modalService.dismissAll();
        this.store.dispatch(
          setDeleteFranchiseSuccess({ success: null })
        );        
      }
    });

  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onClickDeleteFranchiseOnly() {
    this.store.dispatch(
      invokeDeleteFranchiseAndSomeLocations({
        franchise: this.companyName,
        locations: []
      })
    );
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.DELETE,
      UserHistoryServicesEnum.DELETE_ONLY_FRANCHISE
    );
  }
  onClickDeleteAlongWithLocations() {
    this.store.dispatch(
      invokeDeleteFranchiseAndSomeLocations({
        franchise: this.companyName,
        locations: this.selectedLocations
      })
    );
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.DELETE,
      UserHistoryServicesEnum.DELETE_FRANCHISE_AND_FRANCHISED
    );
  }
}
